import { LockFilled, UserOutlined } from "@ant-design/icons";
import { Alert, Divider, Form, Input, Typography } from "antd";
import { FunctionComponent, useCallback, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateIfMounted } from "use-state-if-mounted";
import ActionBtn from "../../shared/action-btn";
import { ROUTE_PUBLIC_SIGN_IN } from "../../shared/app-constants";
import getErrorMessage from "../../shared/get-error-msg";
import getPublicRoute from "../../shared/get-public-route";
import { LocalStorageManager } from "../../shared/local-storage-manager";
import { AppContext } from "../contexts/app-context";
import HttpClient from "../http-client";

interface AcceptInvitationPageProps {}

const organizationCheckCache: any = {};

const AcceptInvitationPage: FunctionComponent<
  AcceptInvitationPageProps
> = () => {
  const [busy, setBusy] = useStateIfMounted(false);
  const [serverMsg, setServerMsg] = useStateIfMounted<string | undefined>(
    undefined
  );
  const [serverMsgType, setServerMsgType] = useStateIfMounted<
    "error" | "success" | undefined
  >(undefined);
  const navigate = useNavigate();
  const params = useParams();
  const { setUser } = useContext(AppContext);

  const next = useCallback(
    async (userData: any) => {
      setBusy(true);
      setServerMsg(undefined);
      userData.email = params.email!;
      userData.invitation_token = params.token!;
      try {
        const { data } = await HttpClient.post("user/invite/accept", userData);
        if (data?.data?.access_token) {
          const { access_token, refresh_token } = data.data;
          setServerMsgType("success");
          setServerMsg("You are successfully logged in!");
          LocalStorageManager.saveTokens(access_token, refresh_token);
          setUser(data.data);
        } else {
          throw new Error("Login failed!");
        }
      } catch (error: any) {
        if (error?.response?.data?.error) {
          setServerMsgType("error");
          setServerMsg(getErrorMessage(error?.response?.data));
        }
      }
      setBusy(false);
    },
    [params]
  );
  return (
    <div className="form-container">
      <Form onFinish={next} className="public-form">
        <Typography.Title level={4} className="title">
          Complete your registration!
        </Typography.Title>
        {serverMsg && (
          <Alert
            type={serverMsgType}
            message={serverMsg}
            style={{ marginBottom: 10 }}
          />
        )}
        <Form.Item
          name="name"
          rules={[{ required: true, message: "Name is required!" }]}
        >
          <Input suffix={<UserOutlined />} placeholder="Your name!" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, min: 6, message: "Password is required!" }]}
        >
          <Input
            suffix={<LockFilled />}
            type="password"
            placeholder="Your password"
          />
        </Form.Item>
        <Form.Item>
          <ActionBtn
            busy={busy}
            type="primary"
            htmlType="submit"
            className="button"
          >
            Complete registration
          </ActionBtn>
        </Form.Item>
        <Divider orientation="center">Or</Divider>
        <div className="tc">
          <Link to={{ pathname: getPublicRoute({}, ROUTE_PUBLIC_SIGN_IN) }}>
            Login
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default AcceptInvitationPage;
